var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "clagh",
  "block.minecraft.granite": "clagh hryal",
  "block.minecraft.polished_granite": "clagh hryal karrit",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "polished diorite",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "polished andesite",
  "block.minecraft.grass_block": "block faiyr",
  "block.minecraft.dirt": "ooir",
  "block.minecraft.coarse_dirt": "coarse dirt",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "warped nylium",
  "block.minecraft.cobblestone": "mooirlaig",
  "block.minecraft.oak_planks": "darree plankyn",
  "block.minecraft.spruce_planks": "juys loghlinagh plankyn",
  "block.minecraft.birch_planks": "slatt plankyn",
  "block.minecraft.jungle_planks": "doofyr plankyn",
  "block.minecraft.acacia_planks": "acaashey plankyn",
  "block.minecraft.dark_oak_planks": "plankyn darragh doo",
  "block.minecraft.crimson_planks": "crimson planks",
  "block.minecraft.warped_planks": "warped planks",
  "block.minecraft.oak_sapling": "darragh aeg",
  "block.minecraft.spruce_sapling": "juys aeg",
  "block.minecraft.birch_sapling": "beih aeg",
  "block.minecraft.jungle_sapling": "billey keylley-gloo aeg",
  "block.minecraft.acacia_sapling": "billey aeg acaashey",
  "block.minecraft.dark_oak_sapling": "billey aeg darragh doo",
  "block.minecraft.bedrock": "bun-charrick",
  "block.minecraft.sand": "geinnagh",
  "block.minecraft.red_sand": "geinnagh jiarg",
  "block.minecraft.gravel": "garvel",
  "block.minecraft.gold_ore": "meain airhey",
  "block.minecraft.iron_ore": "meain yiarn",
  "block.minecraft.coal_ore": "meain gheayil",
  "block.minecraft.nether_gold_ore": "nether meain airhey",
  "block.minecraft.oak_log": "kiap darragh",
  "block.minecraft.spruce_log": "kiap juys",
  "block.minecraft.birch_log": "kiap beih",
  "block.minecraft.jungle_log": "kiap doofyr",
  "block.minecraft.acacia_log": "kiap acaashey",
  "block.minecraft.dark_oak_log": "kiap darragh doo",
  "block.minecraft.crimson_stem": "crimson stem",
  "block.minecraft.warped_stem": "warped stem",
  "block.minecraft.stripped_oak_log": "kiap darragh speeinit",
  "block.minecraft.stripped_spruce_log": "kiap juys speeinit",
  "block.minecraft.stripped_birch_log": "kiap beih speeinit",
  "block.minecraft.stripped_jungle_log": "kiap doofyr speeinit",
  "block.minecraft.stripped_acacia_log": "kiap acaashey speeinit",
  "block.minecraft.stripped_dark_oak_log": "kiap darragh doo speeinit",
  "block.minecraft.stripped_crimson_stem": "stripped crimson stem",
  "block.minecraft.stripped_warped_stem": "stripped warped stem",
  "block.minecraft.stripped_oak_wood": "fuygh darragh speeinit",
  "block.minecraft.stripped_spruce_wood": "fuygh juys speeinit",
  "block.minecraft.stripped_birch_wood": "fuygh beih speeinit",
  "block.minecraft.stripped_jungle_wood": "fuygh doofyr speeinit",
  "block.minecraft.stripped_acacia_wood": "fuygh acaashey speeinit",
  "block.minecraft.stripped_dark_oak_wood": "fuygh darragh doo speeinit",
  "block.minecraft.stripped_crimson_hyphae": "stripped crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "stripped warped hyphae",
  "block.minecraft.oak_wood": "fuygh darree",
  "block.minecraft.spruce_wood": "fuygh juys",
  "block.minecraft.birch_wood": "fuygh beih",
  "block.minecraft.jungle_wood": "fuygh keylley-gloo",
  "block.minecraft.acacia_wood": "fuygh acaashey",
  "block.minecraft.dark_oak_wood": "fuygh darree doo",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "warped hyphae",
  "block.minecraft.oak_leaves": "duillagyn darree",
  "block.minecraft.spruce_leaves": "duillagyn juys",
  "block.minecraft.birch_leaves": "duillagyn beih",
  "block.minecraft.jungle_leaves": "duillagyn keylley-gloo",
  "block.minecraft.acacia_leaves": "duillagyn acaashey",
  "block.minecraft.dark_oak_leaves": "duillagyn darree doo",
  "block.minecraft.sponge": "thoag",
  "block.minecraft.wet_sponge": "thoag ushlagh",
  "block.minecraft.glass": "glonney",
  "block.minecraft.lapis_ore": "meain lapis lazuli",
  "block.minecraft.lapis_block": "block lapis lazuli",
  "block.minecraft.dispenser": "rheynneyder",
  "block.minecraft.sandstone": "clagh gheinnee",
  "block.minecraft.chiseled_sandstone": "clagh gheinnee grainnit",
  "block.minecraft.cut_sandstone": "cut sandstone",
  "block.minecraft.note_block": "block kiaullee",
  "block.minecraft.powered_rail": "railley bree",
  "block.minecraft.detector_rail": "railley brahagh",
  "block.minecraft.sticky_piston": "sooaghan lhiantagh",
  "block.minecraft.cobweb": "feegan",
  "block.minecraft.grass": "faiyr",
  "block.minecraft.fern": "renniagh",
  "block.minecraft.dead_bush": "crouw lhome",
  "block.minecraft.seagrass": "mooir-faiyr",
  "block.minecraft.sea_pickle": "piggyl keayne",
  "block.minecraft.piston": "sooaghan",
  "block.minecraft.white_wool": "ollan bane",
  "block.minecraft.orange_wool": "ollan yiarg-buigh",
  "block.minecraft.magenta_wool": "ollan vajentey",
  "block.minecraft.light_blue_wool": "ollan vane-ghorrym",
  "block.minecraft.yellow_wool": "ollan wuigh",
  "block.minecraft.lime_wool": "ollan ghlass theiley",
  "block.minecraft.pink_wool": "ollan vane-jiarg",
  "block.minecraft.gray_wool": "ollan lheeah",
  "block.minecraft.light_gray_wool": "ollan lheeah-ghlass",
  "block.minecraft.cyan_wool": "ollan cheean",
  "block.minecraft.purple_wool": "ollan yiarg-ghorrym",
  "block.minecraft.blue_wool": "ollan ghorrym",
  "block.minecraft.brown_wool": "ollan ghone",
  "block.minecraft.green_wool": "ollan ghlass",
  "block.minecraft.red_wool": "ollan yiarg",
  "block.minecraft.black_wool": "ollan ghoo",
  "block.minecraft.dandelion": "lus ny minnag",
  "block.minecraft.poppy": "lus y chadlee",
  "block.minecraft.blue_orchid": "bwoid saggyrt gorrym",
  "block.minecraft.allium": "garleid",
  "block.minecraft.azure_bluet": "gorrymeen speyroil",
  "block.minecraft.red_tulip": "laayl yiarg-buigh",
  "block.minecraft.orange_tulip": "laayl yiarg-buigh",
  "block.minecraft.white_tulip": "laayl vane-jiarg",
  "block.minecraft.pink_tulip": "laayl vane-jiarg",
  "block.minecraft.oxeye_daisy": "neaynin mooar",
  "block.minecraft.cornflower": "blaa arroo",
  "block.minecraft.lily_of_the_valley": "lilee y choan",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "shalmane dhone",
  "block.minecraft.red_mushroom": "shalmane jiarg",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "warped fungus",
  "block.minecraft.crimson_roots": "crimson roots",
  "block.minecraft.warped_roots": "warped roots",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping vines",
  "block.minecraft.twisting_vines": "twisting vines",
  "block.minecraft.sugar_cane": "cuirtlagh villish",
  "block.minecraft.kelp": "famlagh",
  "block.minecraft.bamboo": "cuirtlagh",
  "block.minecraft.gold_block": "block yn airhey",
  "block.minecraft.iron_block": "block yn yiarn",
  "block.minecraft.oak_slab": "leac ny darragh",
  "block.minecraft.spruce_slab": "leac ny juys loghlinagh",
  "block.minecraft.birch_slab": "leac ny beih",
  "block.minecraft.jungle_slab": "leac ny doofyr",
  "block.minecraft.acacia_slab": "leac ny acaashey",
  "block.minecraft.dark_oak_slab": "laac ny darree dorraghey",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "warped slab",
  "block.minecraft.stone_slab": "leac chloaie",
  "block.minecraft.smooth_stone_slab": "leac ny clagh meeley",
  "block.minecraft.sandstone_slab": "leac chlagh gheinnee",
  "block.minecraft.cut_sandstone_slab": "leac ny clagh gheinnee giarit",
  "block.minecraft.petrified_oak_slab": "petrified oak slab",
  "block.minecraft.cobblestone_slab": "leac ass mooirlaigyn",
  "block.minecraft.brick_slab": "leac ny breek",
  "block.minecraft.stone_brick_slab": "stone brick slab",
  "block.minecraft.nether_brick_slab": "leac ass breekyn dowin",
  "block.minecraft.quartz_slab": "leac chlagh ghreiney",
  "block.minecraft.red_sandstone_slab": "leac clagh gheinnee jiarg",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "leac purpur",
  "block.minecraft.prismarine_slab": "laac prismarrey",
  "block.minecraft.prismarine_brick_slab": "laac breek prismarine",
  "block.minecraft.dark_prismarine_slab": "laac prismarrey dorraghey",
  "block.minecraft.smooth_quartz": "smooth quartz block",
  "block.minecraft.smooth_red_sandstone": "clagh gheinnee meeley jiarg",
  "block.minecraft.smooth_sandstone": "clagh gheinnee rea",
  "block.minecraft.smooth_stone": "clagh meeley",
  "block.minecraft.bricks": "breekyn",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "skelloo lioar",
  "block.minecraft.mossy_cobblestone": "keynnagh mooirlaig",
  "block.minecraft.obsidian": "creg glessagh",
  "block.minecraft.torch": "lostan",
  "block.minecraft.end_rod": "slat oirr",
  "block.minecraft.chorus_plant": "losserey chorus",
  "block.minecraft.chorus_flower": "blaa chorus",
  "block.minecraft.purpur_block": "glout purpur",
  "block.minecraft.purpur_pillar": "colloo purpur",
  "block.minecraft.purpur_stairs": "greeshyn purpur",
  "block.minecraft.spawner": "gienneyder",
  "block.minecraft.oak_stairs": "greeshyn darree",
  "block.minecraft.chest": "kistey",
  "block.minecraft.diamond_ore": "meain ghiaman",
  "block.minecraft.diamond_block": "block diaman",
  "block.minecraft.crafting_table": "boayrd keirdey",
  "block.minecraft.farmland": "thalloo balley",
  "block.minecraft.furnace": "furnish",
  "block.minecraft.ladder": "aarey",
  "block.minecraft.rail": "railley",
  "block.minecraft.cobblestone_stairs": "greeishyn cloaie",
  "block.minecraft.lever": "corrag",
  "block.minecraft.stone_pressure_plate": "preays-plait clagh",
  "block.minecraft.oak_pressure_plate": "preays-plait darragh",
  "block.minecraft.spruce_pressure_plate": "preays-plait juys",
  "block.minecraft.birch_pressure_plate": "preays-plait beih",
  "block.minecraft.jungle_pressure_plate": "preays-plait doofyr",
  "block.minecraft.acacia_pressure_plate": "preays-plait acaashey",
  "block.minecraft.dark_oak_pressure_plate": "preays-plait darragh doo",
  "block.minecraft.crimson_pressure_plate": "crimson pressure plate",
  "block.minecraft.warped_pressure_plate": "warped pressure plate",
  "block.minecraft.polished_blackstone_pressure_plate": "polished blackstone pressure plate",
  "block.minecraft.redstone_ore": "meain chlagh yiarg",
  "block.minecraft.redstone_torch": "doagan clagh yiarg",
  "block.minecraft.snow": "sniaghtey",
  "block.minecraft.ice": "rio",
  "block.minecraft.snow_block": "block ny sniaghtey",
  "block.minecraft.cactus": "cactys",
  "block.minecraft.clay": "cray",
  "block.minecraft.jukebox": "kishtey kiaullee",
  "block.minecraft.oak_fence": "cleigh",
  "block.minecraft.spruce_fence": "cleigh juys",
  "block.minecraft.birch_fence": "cleigh beih",
  "block.minecraft.jungle_fence": "cleigh doofyr",
  "block.minecraft.acacia_fence": "cleigh acaashey",
  "block.minecraft.dark_oak_fence": "cleigh darree doo",
  "block.minecraft.crimson_fence": "crimson fence",
  "block.minecraft.warped_fence": "warped fence",
  "block.minecraft.pumpkin": "pumkin",
  "block.minecraft.carved_pumpkin": "pumkin giarrit",
  "block.minecraft.netherrack": "geayl dowin",
  "block.minecraft.soul_sand": "geinnagh anmey",
  "block.minecraft.soul_soil": "soul soil",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polished basalt",
  "block.minecraft.soul_torch": "soul torch",
  "block.minecraft.glowstone": "clagh sollysh",
  "block.minecraft.jack_o_lantern": "jack sounag",
  "block.minecraft.oak_trapdoor": "cooylley hroggee darree",
  "block.minecraft.spruce_trapdoor": "cooylley hroggee juys",
  "block.minecraft.birch_trapdoor": "cooylley hroggee beih",
  "block.minecraft.jungle_trapdoor": "cooylley hroggee doofyr",
  "block.minecraft.acacia_trapdoor": "cooylley hroggee acaashey",
  "block.minecraft.dark_oak_trapdoor": "cooylley hroggee darree doo",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "warped trapdoor",
  "block.minecraft.infested_stone": "clagh er chroo lesh",
  "block.minecraft.infested_cobblestone": "mooirlaig er chroo lesh",
  "block.minecraft.infested_stone_bricks": "breekyn clagh er chroo lesh",
  "block.minecraft.infested_mossy_stone_bricks": "breekyn clagh cheynnagh er chroo lesh",
  "block.minecraft.infested_cracked_stone_bricks": "breekyn clagh brisht er chroo lesh",
  "block.minecraft.infested_chiseled_stone_bricks": "breekyn clagh ghrainney er chroo lesh",
  "block.minecraft.stone_bricks": "breekyn cloaie",
  "block.minecraft.mossy_stone_bricks": "breekyn cloaie fo keynnagh",
  "block.minecraft.cracked_stone_bricks": "breekyn cloaie brisht",
  "block.minecraft.chiseled_stone_bricks": "breekyn cloaie grainnit",
  "block.minecraft.brown_mushroom_block": "block shalmane dhone",
  "block.minecraft.red_mushroom_block": "jiarg shalmane block",
  "block.minecraft.mushroom_stem": "stholk shalmane",
  "block.minecraft.iron_bars": "barryn yiarn",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "kerrin glonney",
  "block.minecraft.melon": "mellyn",
  "block.minecraft.vine": "biljyn feeney",
  "block.minecraft.oak_fence_gate": "giat cleigh",
  "block.minecraft.spruce_fence_gate": "cleigh-giatt juys",
  "block.minecraft.birch_fence_gate": "cleigh-giatt beih",
  "block.minecraft.jungle_fence_gate": "cleigh-giatt doofyr",
  "block.minecraft.acacia_fence_gate": "cleigh-giatt acaashey",
  "block.minecraft.dark_oak_fence_gate": "cleigh-giatt darragh doo",
  "block.minecraft.crimson_fence_gate": "crimson fence gate",
  "block.minecraft.warped_fence_gate": "warped fence gate",
  "block.minecraft.brick_stairs": "greeishyn breekey",
  "block.minecraft.stone_brick_stairs": "greeishyn breek cloaie",
  "block.minecraft.mycelium": "crackan shalmane",
  "block.minecraft.lily_pad": "duillag lilee",
  "block.minecraft.nether_bricks": "nether breekyn",
  "block.minecraft.cracked_nether_bricks": "cracked nether bricks",
  "block.minecraft.chiseled_nether_bricks": "grainnit  nether breekyn",
  "block.minecraft.nether_brick_fence": "cleigh breek dowin",
  "block.minecraft.nether_brick_stairs": "greeishyn breek dowin",
  "block.minecraft.enchanting_table": "boayrd obbee",
  "block.minecraft.end_portal_frame": "end portal frame",
  "block.minecraft.end_stone": "clagh yerree",
  "block.minecraft.end_stone_bricks": "end stone bricks",
  "block.minecraft.dragon_egg": "ooh ghragan",
  "block.minecraft.redstone_lamp": "lostan clagh yiarg",
  "block.minecraft.sandstone_stairs": "greeishyn clagh gheinnee",
  "block.minecraft.emerald_ore": "meain smaragaid",
  "block.minecraft.ender_chest": "coyr y jerree",
  "block.minecraft.tripwire_hook": "dooan snapperal",
  "block.minecraft.emerald_block": "block smaragaid",
  "block.minecraft.spruce_stairs": "greeshyn juys loghlinagh",
  "block.minecraft.birch_stairs": "greeshyn beih",
  "block.minecraft.jungle_stairs": "greeshyn doofyr",
  "block.minecraft.crimson_stairs": "crimson stairs",
  "block.minecraft.warped_stairs": "warped stairs",
  "block.minecraft.command_block": "block stiuree",
  "block.minecraft.beacon": "aile rauee",
  "block.minecraft.cobblestone_wall": "boalley mooirlaig",
  "block.minecraft.mossy_cobblestone_wall": "boalley mooirlaig fo keynnagh",
  "block.minecraft.brick_wall": "brick wall",
  "block.minecraft.prismarine_wall": "prismarine wall",
  "block.minecraft.red_sandstone_wall": "red sandstone wall",
  "block.minecraft.mossy_stone_brick_wall": "mossy stone brick wall",
  "block.minecraft.granite_wall": "boalley clagh hryal",
  "block.minecraft.stone_brick_wall": "stone brick wall",
  "block.minecraft.nether_brick_wall": "nether brick wall",
  "block.minecraft.andesite_wall": "andesite wall",
  "block.minecraft.red_nether_brick_wall": "red nether brick wall",
  "block.minecraft.sandstone_wall": "sandstone wall",
  "block.minecraft.end_stone_brick_wall": "end stone brick wall",
  "block.minecraft.diorite_wall": "diorite wall",
  "block.minecraft.blackstone_wall": "blackstone wall",
  "block.minecraft.polished_blackstone_wall": "polished blackstone wall",
  "block.minecraft.polished_blackstone_brick_wall": "polished blackstone brick wall",
  "block.minecraft.stone_button": "cramman clagh",
  "block.minecraft.oak_button": "cramman darragh",
  "block.minecraft.spruce_button": "cramman juys",
  "block.minecraft.birch_button": "cramman beih",
  "block.minecraft.jungle_button": "cramman doofyr",
  "block.minecraft.acacia_button": "cramman acaashey",
  "block.minecraft.dark_oak_button": "cramman darragh doo",
  "block.minecraft.crimson_button": "crimson button",
  "block.minecraft.warped_button": "warped button",
  "block.minecraft.polished_blackstone_button": "polished blackstone button",
  "block.minecraft.anvil": "ingan",
  "block.minecraft.chipped_anvil": "ingan spolgit",
  "block.minecraft.damaged_anvil": "ingan jeeyllit",
  "block.minecraft.trapped_chest": "kistey as ribbey er",
  "block.minecraft.light_weighted_pressure_plate": "light weighted pressure plate",
  "block.minecraft.heavy_weighted_pressure_plate": "heavy weighted pressure plate",
  "block.minecraft.daylight_detector": "brahder greiney",
  "block.minecraft.redstone_block": "block clagh yiarg",
  "block.minecraft.nether_quartz_ore": "meain chlagh ghreiney dowin",
  "block.minecraft.hopper": "crannag nheeghyn",
  "block.minecraft.chiseled_quartz_block": "block clagh ghreiney grainnit",
  "block.minecraft.quartz_block": "block clagh ghreiney",
  "block.minecraft.quartz_bricks": "quartz bricks",
  "block.minecraft.quartz_pillar": "colloo clarinagh vane",
  "block.minecraft.quartz_stairs": "greeishyn clagh ghreiney",
  "block.minecraft.activator_rail": "railley greinnee",
  "block.minecraft.dropper": "tuitteyder",
  "block.minecraft.white_terracotta": "cray vroit vane",
  "block.minecraft.orange_terracotta": "cray vroit oranje",
  "block.minecraft.magenta_terracotta": "cray vroit majentey",
  "block.minecraft.light_blue_terracotta": "cray vroit vane-gorrym",
  "block.minecraft.yellow_terracotta": "cray vroit bwee",
  "block.minecraft.lime_terracotta": "cray vroit vane-geayney",
  "block.minecraft.pink_terracotta": "cray vroit vane-yiarg",
  "block.minecraft.gray_terracotta": "cray vroit lheeah",
  "block.minecraft.light_gray_terracotta": "cray vroit vane-lheeah",
  "block.minecraft.cyan_terracotta": "cray vroit gorrym-geayney",
  "block.minecraft.purple_terracotta": "cray vroit yiarg-gorrym",
  "block.minecraft.blue_terracotta": "cray vroit gorrym",
  "block.minecraft.brown_terracotta": "cray vroit dhone",
  "block.minecraft.green_terracotta": "cray vroit geayney",
  "block.minecraft.red_terracotta": "cray vroit yiarg",
  "block.minecraft.black_terracotta": "cray vroit doo",
  "block.minecraft.barrier": "cagliagh",
  "block.minecraft.iron_trapdoor": "cooylley hroggee yiarn",
  "block.minecraft.hay_block": "bunney traagh",
  "block.minecraft.white_carpet": "brat laare bane",
  "block.minecraft.orange_carpet": "brat laare jiarg-buigh",
  "block.minecraft.magenta_carpet": "brat laare majentey",
  "block.minecraft.light_blue_carpet": "brat laare bane-ghorrym",
  "block.minecraft.yellow_carpet": "brat laare buigh",
  "block.minecraft.lime_carpet": "brat laare glass theiley",
  "block.minecraft.pink_carpet": "brat laare bane-jiarg",
  "block.minecraft.gray_carpet": "brat laare lheean",
  "block.minecraft.light_gray_carpet": "brat laare lheeah-ghlass",
  "block.minecraft.cyan_carpet": "brat laare keean",
  "block.minecraft.purple_carpet": "brat laare gorrym-jiarg",
  "block.minecraft.blue_carpet": "brat laare gorrym",
  "block.minecraft.brown_carpet": "brat laare dhone",
  "block.minecraft.green_carpet": "brat laare glass",
  "block.minecraft.red_carpet": "brat laare jiarg",
  "block.minecraft.black_carpet": "brat laare doo",
  "block.minecraft.terracotta": "cray vroit",
  "block.minecraft.coal_block": "block geayil",
  "block.minecraft.packed_ice": "rio broojit",
  "block.minecraft.acacia_stairs": "greeshyn acaashey",
  "block.minecraft.dark_oak_stairs": "greeshyn darree doo",
  "block.minecraft.slime_block": "glooie block",
  "block.minecraft.grass_path": "cassan faiyr",
  "block.minecraft.sunflower": "lus ny greiney",
  "block.minecraft.lilac": "laylac",
  "block.minecraft.rose_bush": "rosag",
  "block.minecraft.peony": "lus ny gruinnag",
  "block.minecraft.tall_grass": "faiyr liauyr",
  "block.minecraft.large_fern": "renniagh vooar",
  "block.minecraft.white_stained_glass": "glonney ghaait bane",
  "block.minecraft.orange_stained_glass": "glonney ghaait jiarg-buigh",
  "block.minecraft.magenta_stained_glass": "glonney ghaait majentey",
  "block.minecraft.light_blue_stained_glass": "glonney ghaait bane-ghorrym",
  "block.minecraft.yellow_stained_glass": "glonney ghaait buigh",
  "block.minecraft.lime_stained_glass": "glonney ghaait glass teiley",
  "block.minecraft.pink_stained_glass": "glonney ghaait bane-jiarg",
  "block.minecraft.gray_stained_glass": "glonney ghaait lheeah",
  "block.minecraft.light_gray_stained_glass": "glonney ghaait lheeah-ghlass",
  "block.minecraft.cyan_stained_glass": "glonney ghaait keean",
  "block.minecraft.purple_stained_glass": "glonney ghaait jiarg-ghorrym",
  "block.minecraft.blue_stained_glass": "glonney ghaait gorrym",
  "block.minecraft.brown_stained_glass": "glonney ghaait dhone",
  "block.minecraft.green_stained_glass": "glonney ghaait glass",
  "block.minecraft.red_stained_glass": "glonney ghaait jiarg",
  "block.minecraft.black_stained_glass": "glonney ghaait doo",
  "block.minecraft.white_stained_glass_pane": "kerrin glonney ghaait bane",
  "block.minecraft.orange_stained_glass_pane": "kerrin glonney ghaait jiarg-buigh",
  "block.minecraft.magenta_stained_glass_pane": "kerrin glonney ghaait majentey",
  "block.minecraft.light_blue_stained_glass_pane": "kerrin glonney ghaait bane-ghorrym",
  "block.minecraft.yellow_stained_glass_pane": "kerrin glonney ghaait buigh",
  "block.minecraft.lime_stained_glass_pane": "kerrin glonney ghaait glass theiley",
  "block.minecraft.pink_stained_glass_pane": "kerrin glonney ghaait bane-jiarg",
  "block.minecraft.gray_stained_glass_pane": "kerrin glonney ghaait lheeah",
  "block.minecraft.light_gray_stained_glass_pane": "kerrin glonney ghaait lheeah-ghlass",
  "block.minecraft.cyan_stained_glass_pane": "kerrin glonney ghaait keean",
  "block.minecraft.purple_stained_glass_pane": "kerrin glonney ghaait jiarg-ghorrym",
  "block.minecraft.blue_stained_glass_pane": "kerrin glonney ghaait gorrym",
  "block.minecraft.brown_stained_glass_pane": "kerrin glonney ghaait dhone",
  "block.minecraft.green_stained_glass_pane": "kerrin glonney ghaait glass",
  "block.minecraft.red_stained_glass_pane": "kerrin glonney ghaait jiarg",
  "block.minecraft.black_stained_glass_pane": "kerrin glonney ghaait doo",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "brickyn prismarine",
  "block.minecraft.dark_prismarine": "dark prismarine",
  "block.minecraft.prismarine_stairs": "greeshyn prismarrey",
  "block.minecraft.prismarine_brick_stairs": "greeshyn breek prismarrey",
  "block.minecraft.dark_prismarine_stairs": "greeshyn prismarrey dorraghey",
  "block.minecraft.sea_lantern": "lonteyr keayn",
  "block.minecraft.red_sandstone": "red sandstone",
  "block.minecraft.chiseled_red_sandstone": "chiseled red sandstone",
  "block.minecraft.cut_red_sandstone": "cut red sandstone",
  "block.minecraft.red_sandstone_stairs": "greeshyn clagh gheinnee jiarg",
  "block.minecraft.repeating_command_block": "repeating command block",
  "block.minecraft.chain_command_block": "chain command block",
  "block.minecraft.magma_block": "block ny creg teaystagh",
  "block.minecraft.nether_wart_block": "block ny fahney nether",
  "block.minecraft.warped_wart_block": "warped wart block",
  "block.minecraft.red_nether_bricks": "red nether bricks",
  "block.minecraft.bone_block": "craue block",
  "block.minecraft.structure_void": "folmaghey troggal",
  "block.minecraft.observer": "geilltagh",
  "block.minecraft.shulker_box": "kishtey shulker",
  "block.minecraft.white_shulker_box": "kishtey shulker vane",
  "block.minecraft.orange_shulker_box": "kishtey shulker oranje",
  "block.minecraft.magenta_shulker_box": "kishtey shulker majentey",
  "block.minecraft.light_blue_shulker_box": "kishtey shulker vane-ghorrym",
  "block.minecraft.yellow_shulker_box": "kishtey shulker bwee",
  "block.minecraft.lime_shulker_box": "kishtey shulker vane-geayney",
  "block.minecraft.pink_shulker_box": "kishtey shulker vane-yiarg",
  "block.minecraft.gray_shulker_box": "kishtey shulker lheeah",
  "block.minecraft.light_gray_shulker_box": "kishtey shulker vane-lheeah",
  "block.minecraft.cyan_shulker_box": "kishtey shulker gorrym-geayney",
  "block.minecraft.purple_shulker_box": "kishtey shulker yiarg-gorrym",
  "block.minecraft.blue_shulker_box": "kishtey shulker gorrym",
  "block.minecraft.brown_shulker_box": "kishtey shulker dhone",
  "block.minecraft.green_shulker_box": "kishtey shulker geayney",
  "block.minecraft.red_shulker_box": "kishtey shulker yiarg",
  "block.minecraft.black_shulker_box": "kishtey shulker doo",
  "block.minecraft.white_glazed_terracotta": "cray vroit glonnit bane",
  "block.minecraft.orange_glazed_terracotta": "cray vroit glonnit oranje",
  "block.minecraft.magenta_glazed_terracotta": "cray vroit glonnit majentey",
  "block.minecraft.light_blue_glazed_terracotta": "cray vroit glonnit vane-gorrym",
  "block.minecraft.yellow_glazed_terracotta": "cray vroit glonnit bwee",
  "block.minecraft.lime_glazed_terracotta": "cray vroit glonnit vane-geayney",
  "block.minecraft.pink_glazed_terracotta": "cray vroit glonnit vane-yiarg",
  "block.minecraft.gray_glazed_terracotta": "cray vroit glonnit lheeah",
  "block.minecraft.light_gray_glazed_terracotta": "cray vroit glonnit vane-lheeah",
  "block.minecraft.cyan_glazed_terracotta": "cray vroit glonnit gorrym-geayney",
  "block.minecraft.purple_glazed_terracotta": "cray vroit glonnit yiarg-gorrym",
  "block.minecraft.blue_glazed_terracotta": "cray vroit glonnit gorrym",
  "block.minecraft.brown_glazed_terracotta": "cray vroit glonnit dhone",
  "block.minecraft.green_glazed_terracotta": "cray vroit glonnit geayney",
  "block.minecraft.red_glazed_terracotta": "cray vroit glonnit jiarg",
  "block.minecraft.black_glazed_terracotta": "cray vroit glonnit doo",
  "block.minecraft.white_concrete": "taah bane",
  "block.minecraft.orange_concrete": "taah oranje",
  "block.minecraft.magenta_concrete": "taah majentey",
  "block.minecraft.light_blue_concrete": "taah bane-gorrym",
  "block.minecraft.yellow_concrete": "taah bwee",
  "block.minecraft.lime_concrete": "taah bane-geayney",
  "block.minecraft.pink_concrete": "taah bane-jiarg",
  "block.minecraft.gray_concrete": "taah lheeah",
  "block.minecraft.light_gray_concrete": "taah bane-lheeah",
  "block.minecraft.cyan_concrete": "taah gorrym-geayney",
  "block.minecraft.purple_concrete": "taah jiarg-gorrym",
  "block.minecraft.blue_concrete": "taah gorrym",
  "block.minecraft.brown_concrete": "taah dhone",
  "block.minecraft.green_concrete": "taah geayney",
  "block.minecraft.red_concrete": "taah jiarg",
  "block.minecraft.black_concrete": "taah doo",
  "block.minecraft.white_concrete_powder": "poodyrit taah vane",
  "block.minecraft.orange_concrete_powder": "poodyrit taah oranje",
  "block.minecraft.magenta_concrete_powder": "poodyrit taah majentey",
  "block.minecraft.light_blue_concrete_powder": "poodyrit taah vane-gorrym",
  "block.minecraft.yellow_concrete_powder": "poodyrit taah bwee",
  "block.minecraft.lime_concrete_powder": "poodyrit taah vane-geayney",
  "block.minecraft.pink_concrete_powder": "poodyrit taah vane-yiarg",
  "block.minecraft.gray_concrete_powder": "poodyrit taah lheeah",
  "block.minecraft.light_gray_concrete_powder": "poodyrit taah vane-lheeah",
  "block.minecraft.cyan_concrete_powder": "poodyrit taah gorrym-geayney",
  "block.minecraft.purple_concrete_powder": "poodyrit taah jiarg-gorrym",
  "block.minecraft.blue_concrete_powder": "poodyrit taah gorrym",
  "block.minecraft.brown_concrete_powder": "poodyrit taah dhone",
  "block.minecraft.green_concrete_powder": "poodyrit taah geayney",
  "block.minecraft.red_concrete_powder": "poodyrit taah jiarg",
  "block.minecraft.black_concrete_powder": "poodyrit taah doo",
  "block.minecraft.turtle_egg": "ooh turtyl",
  "block.minecraft.dead_tube_coral_block": "glout corryl pioban marroo",
  "block.minecraft.dead_brain_coral_block": "glout corryl inchyn marroo",
  "block.minecraft.dead_bubble_coral_block": "glout corryl bolganagh marroo",
  "block.minecraft.dead_fire_coral_block": "glout corryl aile marroo",
  "block.minecraft.dead_horn_coral_block": "glout corryl cayrn marroo",
  "block.minecraft.tube_coral_block": "tube coral block",
  "block.minecraft.brain_coral_block": "brain coral block",
  "block.minecraft.bubble_coral_block": "bubble coral block",
  "block.minecraft.fire_coral_block": "fire coral block",
  "block.minecraft.horn_coral_block": "horn coral block",
  "block.minecraft.tube_coral": "tube coral",
  "block.minecraft.brain_coral": "brain coral",
  "block.minecraft.bubble_coral": "bubble coral",
  "block.minecraft.fire_coral": "fire coral",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "dead brain coral",
  "block.minecraft.dead_bubble_coral": "dead bubble coral",
  "block.minecraft.dead_fire_coral": "dead fire coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead tube coral",
  "block.minecraft.tube_coral_fan": "tube coral fan",
  "block.minecraft.brain_coral_fan": "brain coral fan",
  "block.minecraft.bubble_coral_fan": "bubble coral fan",
  "block.minecraft.fire_coral_fan": "fire coral fan",
  "block.minecraft.horn_coral_fan": "horn coral fan",
  "block.minecraft.dead_tube_coral_fan": "dead tube coral fan",
  "block.minecraft.dead_brain_coral_fan": "dead brain coral fan",
  "block.minecraft.dead_bubble_coral_fan": "dead bubble coral fan",
  "block.minecraft.dead_fire_coral_fan": "dead fire coral fan",
  "block.minecraft.dead_horn_coral_fan": "dead horn coral fan",
  "block.minecraft.blue_ice": "rio gorrym",
  "block.minecraft.conduit": "piob ushtey",
  "block.minecraft.polished_granite_stairs": "greeshyn clagh hryal karrit",
  "block.minecraft.smooth_red_sandstone_stairs": "smooth red sandstone stairs",
  "block.minecraft.mossy_stone_brick_stairs": "mossy stone brick stairs",
  "block.minecraft.polished_diorite_stairs": "polished diorite stairs",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobblestone stairs",
  "block.minecraft.end_stone_brick_stairs": "end stone brick stairs",
  "block.minecraft.stone_stairs": "stone stairs",
  "block.minecraft.smooth_sandstone_stairs": "smooth sandstone stairs",
  "block.minecraft.smooth_quartz_stairs": "smooth quartz stairs",
  "block.minecraft.granite_stairs": "greeshyn clagh hryal",
  "block.minecraft.andesite_stairs": "andesite stairs",
  "block.minecraft.red_nether_brick_stairs": "red nether brick stairs",
  "block.minecraft.polished_andesite_stairs": "polished andesite stairs",
  "block.minecraft.diorite_stairs": "diorite stairs",
  "block.minecraft.polished_granite_slab": "leac clagh hryal karrit",
  "block.minecraft.smooth_red_sandstone_slab": "smooth red sandstone slab",
  "block.minecraft.mossy_stone_brick_slab": "mossy stone brick slab",
  "block.minecraft.polished_diorite_slab": "polished diorite slab",
  "block.minecraft.mossy_cobblestone_slab": "mossy cobblestone slab",
  "block.minecraft.end_stone_brick_slab": "end stone brick slab",
  "block.minecraft.smooth_sandstone_slab": "smooth sandstone slab",
  "block.minecraft.smooth_quartz_slab": "smooth quartz slab",
  "block.minecraft.granite_slab": "leac clagh hryal",
  "block.minecraft.andesite_slab": "andesite slab",
  "block.minecraft.red_nether_brick_slab": "red nether brick slab",
  "block.minecraft.polished_andesite_slab": "polished andesite slab",
  "block.minecraft.diorite_slab": "diorite slab",
  "block.minecraft.scaffolding": "scammalt",
  "block.minecraft.iron_door": "dorrys yiarn",
  "block.minecraft.oak_door": "dorrys darragh",
  "block.minecraft.spruce_door": "dorrys juys",
  "block.minecraft.birch_door": "dorrys beih",
  "block.minecraft.jungle_door": "dorrys doofyr",
  "block.minecraft.acacia_door": "dorrys acaashey",
  "block.minecraft.dark_oak_door": "dark oak door",
  "block.minecraft.crimson_door": "crimson door",
  "block.minecraft.warped_door": "warped door",
  "block.minecraft.repeater": "aachoyrtagh clagh yiarg",
  "block.minecraft.comparator": "cosoyleyder clagh yiarg",
  "block.minecraft.structure_block": "glout troggal",
  "block.minecraft.jigsaw": "jigsaw block",
  "item.minecraft.turtle_helmet": "bleayst turtyl□□when on head:□+2 eilley",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "sleayst yiarn□□when in main hand:□+3.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.iron_pickaxe": "speiy-chlagh yiarn□□when in main hand:□+3 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.iron_axe": "teigh yiarn□□when in main hand:□+8 jeeyl soiagh□-3.1 attack speed",
  "item.minecraft.flint_and_steel": "clagh aile as yiarn",
  "item.minecraft.apple": "ooyl",
  "item.minecraft.bow": "bow",
  "item.minecraft.arrow": "side",
  "item.minecraft.coal": "geayl",
  "item.minecraft.charcoal": "geayl fuyghee",
  "item.minecraft.diamond": "diaman",
  "item.minecraft.iron_ingot": "caag yiarn",
  "item.minecraft.gold_ingot": "caag airhey",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "netherite scrap",
  "item.minecraft.iron_sword": "cliwe yiarn□□when in main hand:□+5 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.wooden_sword": "cliwe fuyghee□□when in main hand:□+3 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.wooden_shovel": "sleayst 'uyghee□□when in main hand:□+1.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.wooden_pickaxe": "speiy-chlagh fuyghee□□when in main hand:□+1 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.wooden_axe": "teigh fuyghee□□when in main hand:□+6 jeeyl soiagh□-3.2 attack speed",
  "item.minecraft.stone_sword": "cliwe cloaie□□when in main hand:□+4 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.stone_shovel": "sleayst chloaie□□when in main hand:□+2.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.stone_pickaxe": "speiy-chlagh cloaie□□when in main hand:□+2 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.stone_axe": "teigh chloaie□□when in main hand:□+8 jeeyl soiagh□-3.2 attack speed",
  "item.minecraft.diamond_sword": "cliwe diaman□□when in main hand:□+6 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.diamond_shovel": "sleayst ghiaman□□when in main hand:□+4.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.diamond_pickaxe": "speiy-chlagh diaman□□when in main hand:□+4 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.diamond_axe": "teigh ghiaman□□when in main hand:□+8 jeeyl soiagh□-3 attack speed",
  "item.minecraft.stick": "maidjey",
  "item.minecraft.bowl": "meilley",
  "item.minecraft.mushroom_stew": "broie shalmane",
  "item.minecraft.golden_sword": "cliwe airhey□□when in main hand:□+3 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.golden_shovel": "sleayst airhey□□when in main hand:□+1.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.golden_pickaxe": "speiy-chlagh airhey□□when in main hand:□+1 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.golden_axe": "teigh airhey□□when in main hand:□+6 jeeyl soiagh□-3 attack speed",
  "item.minecraft.netherite_sword": "netherite sword□□when in main hand:□+7 jeeyl soiagh□-2.4 attack speed",
  "item.minecraft.netherite_shovel": "netherite shovel□□when in main hand:□+5.5 jeeyl soiagh□-3 attack speed",
  "item.minecraft.netherite_pickaxe": "netherite pickaxe□□when in main hand:□+5 jeeyl soiagh□-2.8 attack speed",
  "item.minecraft.netherite_axe": "netherite axe□□when in main hand:□+9 jeeyl soiagh□-3 attack speed",
  "item.minecraft.string": "streng",
  "item.minecraft.feather": "fedjag",
  "item.minecraft.gunpowder": "poodyr çhentagh",
  "item.minecraft.wooden_hoe": "corlaig 'uyghee□□when in main hand:□-3 attack speed",
  "item.minecraft.stone_hoe": "corlaig chloaie□□when in main hand:□-2 attack speed",
  "item.minecraft.iron_hoe": "corlaig yiarn□□when in main hand:□-1 attack speed",
  "item.minecraft.diamond_hoe": "corlaig ghiaman□□when in main hand:",
  "item.minecraft.golden_hoe": "corlaig airhey□□when in main hand:□-3 attack speed",
  "item.minecraft.netherite_hoe": "netherite hoe□□when in main hand:",
  "item.minecraft.wheat_seeds": "wheat seeds",
  "item.minecraft.wheat": "curnaght",
  "item.minecraft.bread": "arran",
  "item.minecraft.leather_helmet": "bayrn liareagh□□when on head:□+1 eilley",
  "item.minecraft.leather_chestplate": "cassag liareagh□□when on body:□+3 eilley",
  "item.minecraft.leather_leggings": "breetçhyn liareagh□□when on legs:□+2 eilley",
  "item.minecraft.leather_boots": "bootsyn liareagh□□when on feet:□+1 eilley",
  "item.minecraft.chainmail_helmet": "chainmail helmet□□when on head:□+2 eilley",
  "item.minecraft.chainmail_chestplate": "chainmail chestplate□□when on body:□+5 eilley",
  "item.minecraft.chainmail_leggings": "chainmail leggings□□when on legs:□+4 eilley",
  "item.minecraft.chainmail_boots": "chainmail boots□□when on feet:□+1 eilley",
  "item.minecraft.iron_helmet": "bayrn yiarn□□when on head:□+2 eilley",
  "item.minecraft.iron_chestplate": "eilley phlait yiarn□□when on body:□+6 eilley",
  "item.minecraft.iron_leggings": "breetçhyn yiarn□□when on legs:□+5 eilley",
  "item.minecraft.iron_boots": "bootsyn yiarn□□when on feet:□+2 eilley",
  "item.minecraft.diamond_helmet": "bayrn diaman□□when on head:□+3 eilley□+2 armor toughness",
  "item.minecraft.diamond_chestplate": "eilley phlait diamanagh□□when on body:□+8 eilley□+2 armor toughness",
  "item.minecraft.diamond_leggings": "breetçhyn diaman□□when on legs:□+6 eilley□+2 armor toughness",
  "item.minecraft.diamond_boots": "bootsyn diaman□□when on feet:□+3 eilley□+2 armor toughness",
  "item.minecraft.golden_helmet": "bayrn airhey□□when on head:□+2 eilley",
  "item.minecraft.golden_chestplate": "eilley phlait airhey□□when on body:□+5 eilley",
  "item.minecraft.golden_leggings": "breetçhyn airhey□□when on legs:□+3 eilley",
  "item.minecraft.golden_boots": "bootsyn airhey□□when on feet:□+1 eilley",
  "item.minecraft.netherite_helmet": "netherite helmet□□when on head:□+3 eilley□+3 armor toughness□+1 shassooaght noi seiy ergooyl",
  "item.minecraft.netherite_chestplate": "netherite chestplate□□when on body:□+8 eilley□+3 armor toughness□+1 shassooaght noi seiy ergooyl",
  "item.minecraft.netherite_leggings": "netherite leggings□□when on legs:□+6 eilley□+3 armor toughness□+1 shassooaght noi seiy ergooyl",
  "item.minecraft.netherite_boots": "netherite boots□□when on feet:□+3 eilley□+3 armor toughness□+1 shassooaght noi seiy ergooyl",
  "item.minecraft.flint": "clagh aile",
  "item.minecraft.porkchop": "asney muick aw",
  "item.minecraft.cooked_porkchop": "asney muick aarlit",
  "item.minecraft.painting": "jalloo",
  "item.minecraft.golden_apple": "ooyl airhey",
  "item.minecraft.enchanted_golden_apple": "enchanted golden apple",
  "block.minecraft.oak_sign": "fogrey darragh",
  "block.minecraft.spruce_sign": "fogrey juys",
  "block.minecraft.birch_sign": "fogrey beih",
  "block.minecraft.jungle_sign": "fogrey doofyr",
  "block.minecraft.acacia_sign": "fogrey acaashey",
  "block.minecraft.dark_oak_sign": "fogrey darree dorraghey",
  "block.minecraft.crimson_sign": "crimson sign",
  "block.minecraft.warped_sign": "warped sign",
  "item.minecraft.bucket": "cruick",
  "item.minecraft.water_bucket": "cruick ushtey",
  "item.minecraft.lava_bucket": "cruick leavey",
  "item.minecraft.minecart": "cairt veainey",
  "item.minecraft.saddle": "jeelt",
  "item.minecraft.redstone": "joan clagh yiarg",
  "item.minecraft.snowball": "bluckan sniaghtee",
  "item.minecraft.oak_boat": "baatey darragh",
  "item.minecraft.leather": "liare",
  "item.minecraft.milk_bucket": "lane cruick ny bainney",
  "item.minecraft.pufferfish_bucket": "cruick ny eeast bolgagh",
  "item.minecraft.salmon_bucket": "cruick ny braddan",
  "item.minecraft.cod_bucket": "lane cruick ny boiddagh",
  "item.minecraft.tropical_fish_bucket": "lane cruick ny eeastyn grianchryssagh",
  "item.minecraft.brick": "breek",
  "item.minecraft.clay_ball": "clay ball",
  "block.minecraft.dried_kelp_block": "famlagh block heer",
  "item.minecraft.paper": "pabyr",
  "item.minecraft.book": "lioar",
  "item.minecraft.slime_ball": "bluckan glooie",
  "item.minecraft.chest_minecart": "cairt veainey lesh coyr",
  "item.minecraft.furnace_minecart": "cairt veainey lesh furnish",
  "item.minecraft.egg": "ooh",
  "item.minecraft.compass": "combaase",
  "item.minecraft.fishing_rod": "slat eeastee",
  "item.minecraft.clock": "clag",
  "item.minecraft.glowstone_dust": "joan clagh hollysh",
  "item.minecraft.cod": "boiddagh aw",
  "item.minecraft.salmon": "braddan aw",
  "item.minecraft.tropical_fish": "eeastyn grianchryssagh",
  "item.minecraft.pufferfish": "eeast bolgagh",
  "item.minecraft.cooked_cod": "boiddagh coagyrit",
  "item.minecraft.cooked_salmon": "braddan coagyrit",
  "item.minecraft.ink_sac": "bolgan doo",
  "item.minecraft.red_dye": "daah jiarg",
  "item.minecraft.green_dye": "daah geayney",
  "item.minecraft.cocoa_beans": "poanrey coco",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "daah gorrym-jiarg",
  "item.minecraft.cyan_dye": "daah keean",
  "item.minecraft.light_gray_dye": "daah lheeah-ghlass",
  "item.minecraft.gray_dye": "daah lheeah",
  "item.minecraft.pink_dye": "daah bane-yiarg",
  "item.minecraft.lime_dye": "daah glass theiley",
  "item.minecraft.yellow_dye": "yellow dye",
  "item.minecraft.light_blue_dye": "daah bane-ghorrym",
  "item.minecraft.magenta_dye": "daah majentey",
  "item.minecraft.orange_dye": "daah jiarg-buigh",
  "item.minecraft.bone_meal": "daah meinn chraue",
  "item.minecraft.blue_dye": "daah gorrym",
  "item.minecraft.brown_dye": "daah dhone",
  "item.minecraft.black_dye": "daah doo",
  "item.minecraft.white_dye": "daah bane",
  "item.minecraft.bone": "craue",
  "item.minecraft.sugar": "shugyr",
  "block.minecraft.cake": "berreen",
  "block.minecraft.white_bed": "lhiabbee bane",
  "block.minecraft.orange_bed": "lhiabbee jiarg-bwee",
  "block.minecraft.magenta_bed": "lhiabbee majentey",
  "block.minecraft.light_blue_bed": "lhiabbee bane-ghorrym",
  "block.minecraft.yellow_bed": "lhiabbee buigh",
  "block.minecraft.lime_bed": "lhiabbee lheeah-ghlass",
  "block.minecraft.pink_bed": "lhiabbee bane-yiarg",
  "block.minecraft.gray_bed": "lhiabbee lheeah",
  "block.minecraft.light_gray_bed": "lhiabbee lheeah-ghlass",
  "block.minecraft.cyan_bed": "lhiabbee bane-ghorrym",
  "block.minecraft.purple_bed": "lhiabbee jiarg-gorrym",
  "block.minecraft.blue_bed": "lhiabbee gorrym",
  "block.minecraft.brown_bed": "lhiabbee dhone",
  "block.minecraft.green_bed": "lhiabbee geayney",
  "block.minecraft.red_bed": "lhiabbee jiarg",
  "block.minecraft.black_bed": "lhiabbee doo",
  "item.minecraft.cookie": "brishtag",
  "item.minecraft.filled_map": "caslys-çheerey□#0",
  "item.minecraft.shears": "jouish",
  "item.minecraft.melon_slice": "melon slice",
  "item.minecraft.dried_kelp": "dried kelp",
  "item.minecraft.pumpkin_seeds": "rassyn pumkin",
  "item.minecraft.melon_seeds": "rassyn mellyn",
  "item.minecraft.beef": "feill vart aw",
  "item.minecraft.cooked_beef": "stheag",
  "item.minecraft.chicken": "feill chirkey aw",
  "item.minecraft.cooked_chicken": "feill chirkey aarlit",
  "item.minecraft.rotten_flesh": "feill loau",
  "item.minecraft.ender_pearl": "pearl y jerree",
  "item.minecraft.blaze_rod": "slat lossyr",
  "item.minecraft.ghast_tear": "jeir ghowil",
  "item.minecraft.gold_nugget": "cramman airhey",
  "item.minecraft.nether_wart": "lus ny diunidyn",
  "item.minecraft.potion": "uncraftable potion□gyn ymmyrtys",
  "item.minecraft.glass_bottle": "boteil glonney",
  "item.minecraft.spider_eye": "sooill ghoo-oallee",
  "item.minecraft.fermented_spider_eye": "sooill ghoo-oallee imbylit",
  "item.minecraft.blaze_powder": "poodyr lossyr",
  "item.minecraft.magma_cream": "barrag leavey",
  "block.minecraft.brewing_stand": "shasstane imbylagh",
  "block.minecraft.cauldron": "coirrey",
  "item.minecraft.ender_eye": "sooill y jerree",
  "item.minecraft.glistering_melon_slice": "glistering melon slice",
  "item.minecraft.bat_spawn_egg": "ooh er mylgaghey craitnaghyn",
  "item.minecraft.bee_spawn_egg": "ooh er mylgaghey shellanyn",
  "item.minecraft.blaze_spawn_egg": "lossyr mylgaghey ooh",
  "item.minecraft.cat_spawn_egg": "ooh er mylgaghey kiyt",
  "item.minecraft.cave_spider_spawn_egg": "doo-oallee ooig mylgaghey ooh",
  "item.minecraft.chicken_spawn_egg": "ooh er mylgaghey feill chirckaghyn",
  "item.minecraft.cod_spawn_egg": "ooh er mylgaghey giare-voiddaghyn",
  "item.minecraft.cow_spawn_egg": "booa mylgaghey ooh",
  "item.minecraft.creeper_spawn_egg": "shnoageyder mylgaghey ooh",
  "item.minecraft.dolphin_spawn_egg": "ooh er mylgaghey lheimmeyder–marraghyn",
  "item.minecraft.donkey_spawn_egg": "donkey spawn egg",
  "item.minecraft.drowned_spawn_egg": "drowned spawn egg",
  "item.minecraft.elder_guardian_spawn_egg": "elder guardian spawn egg",
  "item.minecraft.enderman_spawn_egg": "jerreyder mylgaghey ooh",
  "item.minecraft.endermite_spawn_egg": "endermite spawn egg",
  "item.minecraft.evoker_spawn_egg": "evoker spawn egg",
  "item.minecraft.fox_spawn_egg": "ooh mylgaghey shynnagh",
  "item.minecraft.ghast_spawn_egg": "ghast spawn egg",
  "item.minecraft.guardian_spawn_egg": "guardian spawn egg",
  "item.minecraft.hoglin_spawn_egg": "hoglin mylgaghey ooh",
  "item.minecraft.horse_spawn_egg": "horse spawn egg",
  "item.minecraft.husk_spawn_egg": "husk spawn egg",
  "item.minecraft.llama_spawn_egg": "llama spawn egg",
  "item.minecraft.magma_cube_spawn_egg": "magma cube spawn egg",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn egg",
  "item.minecraft.mule_spawn_egg": "mule spawn egg",
  "item.minecraft.ocelot_spawn_egg": "ocelot spawn egg",
  "item.minecraft.panda_spawn_egg": "panda spawn egg",
  "item.minecraft.parrot_spawn_egg": "ooh mylgaghey parrad",
  "item.minecraft.phantom_spawn_egg": "ooh mylgaghey scaanjoon",
  "item.minecraft.pig_spawn_egg": "muc mylgaghey ooh",
  "item.minecraft.piglin_spawn_egg": "piglin mylgaghey ooh",
  "item.minecraft.pillager_spawn_egg": "ooh mylgaghey spooilleyder",
  "item.minecraft.polar_bear_spawn_egg": "ooh mylgaghey mucawin-bane",
  "item.minecraft.pufferfish_spawn_egg": "ooh mylgaghey sheideyder-eeast",
  "item.minecraft.rabbit_spawn_egg": "ooh mylgaghey conning",
  "item.minecraft.ravager_spawn_egg": "ravager spawn egg",
  "item.minecraft.salmon_spawn_egg": "ooh mylgaghey braddan",
  "item.minecraft.sheep_spawn_egg": "ooh mylgaghey keyrrey",
  "item.minecraft.shulker_spawn_egg": "ooh mylgaghey shulker",
  "item.minecraft.silverfish_spawn_egg": "ooh mylgaghey argid-eeast",
  "item.minecraft.skeleton_spawn_egg": "ooh mylgaghey ushylagh",
  "item.minecraft.skeleton_horse_spawn_egg": "ooh mylgaghey cabbyl ushylagh",
  "item.minecraft.slime_spawn_egg": "ooh mylgaghey sleetch",
  "item.minecraft.spider_spawn_egg": "doo-oallee mylgaghey ooh",
  "item.minecraft.squid_spawn_egg": "ooh mylgaghey peie vreinn",
  "item.minecraft.stray_spawn_egg": "ooh mylgaghey shaghrynagh",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "ooh mylgaghey laamey traghtalagh",
  "item.minecraft.tropical_fish_spawn_egg": "ooh mylgaghey eeastyn grianchryssagh",
  "item.minecraft.turtle_spawn_egg": "ooh mylgaghey turtyl",
  "item.minecraft.vex_spawn_egg": "vex spawn egg",
  "item.minecraft.villager_spawn_egg": "theayagh mylgaghey ooh",
  "item.minecraft.vindicator_spawn_egg": "ooh mylgaghey coadeyder",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader spawn egg",
  "item.minecraft.witch_spawn_egg": "buitçh mylgaghey ooh",
  "item.minecraft.wither_skeleton_spawn_egg": "ooh mylgaghey ushylagh wither",
  "item.minecraft.wolf_spawn_egg": "ooh mylgaghey moddey oaldey",
  "item.minecraft.zoglin_spawn_egg": "zoglin mylgaghey ooh",
  "item.minecraft.zombie_spawn_egg": "ooh mylgaghey corp fo ghruiaghtys",
  "item.minecraft.zombie_horse_spawn_egg": "zombie horse spawn egg",
  "item.minecraft.zombie_villager_spawn_egg": "zombie villager spawn egg",
  "item.minecraft.zombified_piglin_spawn_egg": "zombified piglin spawn egg",
  "item.minecraft.experience_bottle": "jough ynsee",
  "item.minecraft.fire_charge": "lane doarn d'aile",
  "item.minecraft.writable_book": "lioar as fedjag screeuee",
  "item.minecraft.written_book": "lioar screeuit",
  "item.minecraft.emerald": "smaragaid",
  "item.minecraft.item_frame": "clowan nhee",
  "block.minecraft.flower_pot": "crockan blaa",
  "item.minecraft.carrot": "carradje",
  "item.minecraft.potato": "praase",
  "item.minecraft.baked_potato": "praase oghe",
  "item.minecraft.poisonous_potato": "praase nieunagh",
  "item.minecraft.map": "caslys-çheerey bane",
  "item.minecraft.golden_carrot": "carradje airhey",
  "block.minecraft.skeleton_skull": "kione ushylagh",
  "block.minecraft.wither_skeleton_skull": "kione shirgeyder",
  "block.minecraft.player_head": "player head",
  "block.minecraft.zombie_head": "kione kirpey fo ghruightys",
  "block.minecraft.creeper_head": "kione shnoageyder",
  "block.minecraft.dragon_head": "dragon head",
  "item.minecraft.carrot_on_a_stick": "carradje er maidjey",
  "item.minecraft.warped_fungus_on_a_stick": "warped fungus on a stick",
  "item.minecraft.nether_star": "rollage dowin",
  "item.minecraft.pumpkin_pie": "pye pumkin",
  "item.minecraft.firework_rocket": "çhentag",
  "item.minecraft.firework_star": "rollage çhentag",
  "item.minecraft.enchanted_book": "lioar fo ghruiaghtys",
  "item.minecraft.nether_brick": "breek dowin",
  "item.minecraft.quartz": "clarinagh dowin",
  "item.minecraft.tnt_minecart": "cairt veainey lesh tnt",
  "item.minecraft.hopper_minecart": "cairt veainey lesh crannag",
  "item.minecraft.prismarine_shard": "smooirane prismooiroil",
  "item.minecraft.prismarine_crystals": "crystalyn prismooiroil",
  "item.minecraft.rabbit": "conning aw",
  "item.minecraft.cooked_rabbit": "conning coagyrit",
  "item.minecraft.rabbit_stew": "broish coagyrit",
  "item.minecraft.rabbit_foot": "rabbit's foot",
  "item.minecraft.rabbit_hide": "sheh coagyrit",
  "item.minecraft.armor_stand": "armor stand",
  "item.minecraft.iron_horse_armor": "eilley chabbyl yiarn",
  "item.minecraft.golden_horse_armor": "golden horse armor",
  "item.minecraft.diamond_horse_armor": "eilley chabbyl diaman",
  "item.minecraft.leather_horse_armor": "leather horse armor",
  "item.minecraft.lead": "yeeal",
  "item.minecraft.name_tag": "lipaid ennym",
  "item.minecraft.command_block_minecart": "cairt veainey as block oardee aynjee",
  "item.minecraft.mutton": "muiltchin aw",
  "item.minecraft.cooked_mutton": "muiltchin coagyrit",
  "block.minecraft.white_banner": "brattagh bane",
  "block.minecraft.orange_banner": "brattagh oranje",
  "block.minecraft.magenta_banner": "brattagh majentey",
  "block.minecraft.light_blue_banner": "brattagh bane-gorrym",
  "block.minecraft.yellow_banner": "brattagh bwee",
  "block.minecraft.lime_banner": "brattagh lheeah-ghlass",
  "block.minecraft.pink_banner": "brattagh bane-jiarg",
  "block.minecraft.gray_banner": "brattagh lheeah",
  "block.minecraft.light_gray_banner": "brattagh lheeah-ghlass",
  "block.minecraft.cyan_banner": "brattagh gorrym-geayney",
  "block.minecraft.purple_banner": "brattagh jiarg-gorrym",
  "block.minecraft.blue_banner": "brattagh gorrym",
  "block.minecraft.brown_banner": "brattagh dhone",
  "block.minecraft.green_banner": "brattagh geayney",
  "block.minecraft.red_banner": "brattagh jiarg",
  "block.minecraft.black_banner": "brattagh doo",
  "item.minecraft.end_crystal": "end crystal",
  "item.minecraft.chorus_fruit": "chorus fruit",
  "item.minecraft.popped_chorus_fruit": "popped chorus fruit",
  "item.minecraft.beetroot": "beetys",
  "item.minecraft.beetroot_seeds": "caaee beetys",
  "item.minecraft.beetroot_soup": "anvroie beetys",
  "item.minecraft.dragon_breath": "dragon's breath",
  "item.minecraft.splash_potion": "splash uncraftable potion□gyn ymmyrtys",
  "item.minecraft.spectral_arrow": "fleit scaanagh",
  "item.minecraft.tipped_arrow": "uncraftable tipped arrow□gyn ymmyrtys",
  "item.minecraft.lingering_potion": "lingering uncraftable potion□gyn ymmyrtys",
  "item.minecraft.shield": "skaa",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "baatey juys",
  "item.minecraft.birch_boat": "baatey beih",
  "item.minecraft.jungle_boat": "baatey doofyr",
  "item.minecraft.acacia_boat": "baatey acaashey",
  "item.minecraft.dark_oak_boat": "baatey darragh doo",
  "item.minecraft.totem_of_undying": "cowrey ny bragh farraghtyn",
  "item.minecraft.shulker_shell": "bleayst shulker",
  "item.minecraft.iron_nugget": "iron nugget",
  "item.minecraft.knowledge_book": "knowledge book",
  "item.minecraft.debug_stick": "debug stick",
  "item.minecraft.music_disc_13": "jysk kiaullee□c418 - 13",
  "item.minecraft.music_disc_cat": "jysk kiaullee□c418 - cat",
  "item.minecraft.music_disc_blocks": "jysk kiaullee□c418 - blocks",
  "item.minecraft.music_disc_chirp": "jysk kiaullee□c418 - chirp",
  "item.minecraft.music_disc_far": "jysk kiaullee□c418 - far",
  "item.minecraft.music_disc_mall": "jysk kiaullee□c418 - mall",
  "item.minecraft.music_disc_mellohi": "jysk kiaullee□c418 - mellohi",
  "item.minecraft.music_disc_stal": "jysk kiaullee□c418 - stal",
  "item.minecraft.music_disc_strad": "jysk kiaullee□c418 - strad",
  "item.minecraft.music_disc_ward": "jysk kiaullee□c418 - ward",
  "item.minecraft.music_disc_11": "jysk kiaullee□c418 - 11",
  "item.minecraft.music_disc_wait": "jysk kiaullee□c418 - wait",
  "item.minecraft.music_disc_pigstep": "jysk kiaullee□lena raine - pigstep",
  "item.minecraft.trident": "trooreen□□when in main hand:□+8 jeeyl soiagh□-2.9 attack speed",
  "item.minecraft.phantom_membrane": "phantom membrane",
  "item.minecraft.nautilus_shell": "nautilus shell",
  "item.minecraft.heart_of_the_sea": "heart of the sea",
  "item.minecraft.crossbow": "croshvow",
  "item.minecraft.suspicious_stew": "suspicious stew",
  "block.minecraft.loom": "bart",
  "item.minecraft.flower_banner_pattern": "sambyl brattagh□flower charge",
  "item.minecraft.creeper_banner_pattern": "sambyl brattagh□creeper charge",
  "item.minecraft.skull_banner_pattern": "sambyl brattagh□skull charge",
  "item.minecraft.mojang_banner_pattern": "sambyl brattagh□red",
  "item.minecraft.globe_banner_pattern": "sambyl brattagh□cruinney",
  "item.minecraft.piglin_banner_pattern": "sambyl brattagh□snout",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "barrel",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "blast furnace",
  "block.minecraft.cartography_table": "cartography table",
  "block.minecraft.fletching_table": "fletching table",
  "block.minecraft.grindstone": "clagh vleihveayn",
  "block.minecraft.lectern": "shasstan lioaragh",
  "block.minecraft.smithing_table": "smithing table",
  "block.minecraft.stonecutter": "jallooder cloaie",
  "block.minecraft.bell": "kiaullane",
  "block.minecraft.lantern": "londeyr",
  "block.minecraft.soul_lantern": "soul lantern",
  "item.minecraft.sweet_berries": "berrishyn millish",
  "block.minecraft.campfire": "campaile",
  "block.minecraft.soul_campfire": "soul campfire",
  "block.minecraft.shroomlight": "shroomlight",
  "item.minecraft.honeycomb": "khere volley",
  "block.minecraft.bee_nest": "edd shellan",
  "block.minecraft.beehive": "shelleig",
  "item.minecraft.honey_bottle": "honey bottle",
  "block.minecraft.honey_block": "glout mill",
  "block.minecraft.honeycomb_block": "glout khere volley",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "block of netherite",
  "block.minecraft.ancient_debris": "ancient debris",
  "block.minecraft.target": "target",
  "block.minecraft.crying_obsidian": "crying obsidian",
  "block.minecraft.blackstone": "blackstone",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "blackstone stairs",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "polished blackstone",
  "block.minecraft.polished_blackstone_slab": "polished blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "polished blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "polished blackstone bricks",
  "block.minecraft.polished_blackstone_brick_slab": "polished blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "polished blackstone brick stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked polished blackstone bricks",
  "block.minecraft.respawn_anchor": "respawn anchor",
}
export const gv_im = items; 
